var map = {
	"./applications.svg": 562,
	"./clients.svg": 563,
	"./csv.svg": 564,
	"./dashboard.svg": 565,
	"./help.svg": 566,
	"./iconLogo.svg": 567,
	"./iconLogoOnDark.svg": 568,
	"./logo.svg": 343,
	"./logoOnDark.svg": 569,
	"./monitoring.svg": 570,
	"./notifications.svg": 571,
	"./profile.svg": 572,
	"./quickSearch.svg": 573,
	"./settings.svg": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;